import FormElement from "common/components/FormElement/FormElement";
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { Container,Row,Col,Form,Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {signin} from "modules/user/actions/userActions";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AnimatedBlocks from "common/components/AnimatedIcons/AnimatedBlocks/AnimatedBlocks";
import styles from "./LoginForm.module.scss";
import { getBadHourAndDayMessage, checkDayAndHour } from "common/helpers/HourAndDayChecker";

export default function LoginForm(props){
  const dispatch = useDispatch();
  
  const user = useSelector( state => {
    return state.user;
  });
  const [formerrors,setFormErrors] = useState({});
  const [formData,setFormData] = useState({email:"",password:'', rememberMe:false});

  const onchangeInput = (e) =>{
    let newErrors = {formerrors};
    let newFormData = {...formData};
    newFormData[e.target.name] = e.target.value;
    if (newErrors.hasOwnProperty(e.target.name)) delete newErrors[e.target.name];
    setFormErrors(newErrors);
    setFormData(newFormData);
  }

  const validateData = () =>{
    let newErrors = {};
    setFormErrors(newErrors);
    if (formData.email.trim()==="") newErrors["email"] = "El email no puede estar vacío";
    /*else
      if (!String(formData.email).toLowerCase().match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ))  newErrors["email"] = "E-mail no válido";*/
    if (formData.password.trim()==="") newErrors["password"] = "Por favor ingrese su password";
    setFormErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      return true;
    } else {
      return false;
    }
  }
  const submitHandler = (e) => {
    let result = null;
		e.preventDefault();
    if (validateData()){
        // aqui sign in      
        dispatch(signin(formData.email, formData.password, false));
       
    }
		/*setErrorData({
			emailError: data.email.trim() === '',
			passwordError: data.password.trim() === '',
		});
		if (errorData.emailError || errorData.passwordError) return;
		dispatch(signin(...Object.values(data)));*/
	};

  if (checkDayAndHour()===true)
    return <div>
      
<Container>
        <Row className="justify-content-center align-items-center">
          <Col xs={12}>
                
            
                <div className="mb-3 mt-md-4">
                  <h2 className="fw-bold mb-2  ">Portal de ingreso de obligaciones de pago</h2>
                  <div className={styles.centeraligned + " " +styles.paddingspace}>Acceda a su cuenta</div>
                  <div className="mb-3">
                    {
                      (user.loginStatus.error)? <Alert variant="danger">{user.loginStatus.message}</Alert>:''
                    }
                    {
                      formerrors.__form_general_error && <Alert variant="danger">{formerrors.__form_general_error}</Alert>
                    }
                    <Form onSubmit={submitHandler}>
                      
                      <FormElement 
                          margin="1" 
                          id="formBasicEmail" 
                          label="Usuario" 
                          type="text" 
                          onChange={onchangeInput} 
                          name="email" 
                          error={formerrors.email} 
                          placeholder="Email, No. Proveedor o NIT (sin guiones)"
                      />
                      
                     
                      <FormElement 
                          margin="1" 
                          id="formPassword" 
                          label="Contraseña" 
                          type="password" 
                          onChange={onchangeInput} 
                          name="password" 
                          error={formerrors.password} 
                          placeholder="Contraseña"
                      />
                      <div className={styles.rightaligned+ " "+ styles.paddingspace}>
                        <Link to="/user/forgot">Olvidé mi contraseña</Link>
                      </div>
                      <Form.Group
                        className="mb-3"
                        controlId="formCheckbox"
                      >
                       
                      </Form.Group>
                      <div className="d-grid">
                        <Button variant="primary" type="submit">
                          Iniciar sesión
                        </Button>
                      </div>
                    </Form>
                    {
                      (user.loading == true)? <div className={styles.loadinglogin}> <small><AnimatedBlocks fill="#88c359" stroke="#666" /></small> Autenticando usuario... </div>: ''
                    }
                  </div>
                </div>
   
          </Col>
        </Row>
        <Row>
          <Col className={styles.signupleyend}><hr />¿Primera vez en el portal? <br /><Button href="/user/sign-up">Registrarme</Button></Col>
        </Row>
      </Container>


    </div>;
    else
    return getBadHourAndDayMessage();
}